import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';
import classNames from 'classnames';
import {
  BillingDetailsProfileSubpageMetaOverride,
} from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/BillingDetailsProfileSubpage/BillingDetailsProfileSubpageMetaOverride';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { FDBox, FDStack } from '@facet-wealth/design';

export const useBillingDetailsTableMobileRowStyles = buildUseStyles('BillingDetailsTableMobileRow', (theme) => ({
  control: {
    padding: 0,
    margin: 0,
  },
  invoiceItem: {
    borderTop: `1px solid ${theme.palette.facet.mediumGray3}`,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
  },
  paymentDetails: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  lineItemTypography: {
    fontSize: theme.typography.fontSizePt875Rem,
    color: theme.palette.facet.darkGray,
    fontWeight: theme.typography.fontWeightBold,
  },
  lineItemTypographyExtraBold: {
    fontWeight: theme.typography.fontWeightExtraBold,
  },
  total: {
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightExtraBold,
  },
}));

const BillingDetailsTableMobileRow = ({ resource }) => {
  const theme = useTheme();
  const classes = useBillingDetailsTableMobileRowStyles(theme);
  const invoice = resource;

  return (
    <Box className={classes.invoiceItem} test={'billing-page-payment-source'}>
      <FDBox paddingY={3}>
        <FDStack justifyContent={'space-between'} alignItems="center">
          <MetaControl
            className={classNames(classes.control)}
            metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
            resource={invoice}
            attrName={'description'}
            SpreadProps={{
              ValueProps: {
                className: classes.lineItemTypography,
              },
            }}
          />
          <MetaControl
            className={classNames(classes.control)}
            metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
            resource={invoice}
            attrName={'date'}
            SpreadProps={{
              ValueProps: {
                className: classes.lineItemTypography,
              },
            }}
          />
        </FDStack>
      </FDBox>
      <FDStack justifyContent={'space-between'} alignItems="flex-start">
        <FDStack direction={'column'} flexGrow={1} spacing={1} alignItems="flex-start" justifyContent="flex-start">
          <MetaControl
            className={classNames(classes.control)}
            metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
            resource={invoice}
            attrName={'membershipPeriod'}
            SpreadProps={{
              ValueProps: {
                className: classes.lineItemTypography,
              },
            }}
          />
        </FDStack>
        <MetaControl
          metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
          resource={invoice}
          attrName={'total'}
          SpreadProps={{
            ValueProps: {
              className: classNames(classes.lineItemTypography, classes.total, classes.control),
            },
          }}
        />
      </FDStack>
      <Box className={classes.paymentDetails}>
        <FDStack direction={'row'} justifyContent={'space-between'} alignItems="flex-start">
          <MetaControl
            className={classNames(classes.control)}
            metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
            resource={invoice}
            attrName={'descriptions'}
            SpreadProps={{
              ValueProps: {
                className: classes.lineItemTypography,
              },
            }}
          />
          <MetaControl
            className={classNames(classes.control)}
            metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
            typographyClassName={classes.lineItemTypography}
            resource={invoice}
            attrName={'paymentMethods'}
          />
          <MetaControl
            className={classNames(classes.control)}
            metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
            typographyClassName={classes.lineItemTypography}
            resource={invoice}
            attrName={'subTotals'}
          />
        </FDStack>
      </Box>
      <MetaControl
        className={classNames(classes.control)}
        metaOverrideSet={BillingDetailsProfileSubpageMetaOverride}
        resource={invoice}
        attrName={'status'}
      />
    </Box>
  );
};

BillingDetailsTableMobileRow.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
BillingDetailsTableMobileRow.defaultProps = {};

export default BillingDetailsTableMobileRow;
